<template>
  <div class="module-box-banner">
    <div class="top w" :class="{ active: param.style == 0 }">
      <div
        class="nav"
        :style="{
          backgroundColor: 'rgba(255,255,255,' + param.classify_opacity + ')',
        }"
      >
        <ul>
          <li v-for="(item, index) in param.cat_list" :key="index">
            <div class="ttshop_navtitle" v-if="index < 11">
              <div class="ttshop-nav-icon">
                <img
                  class="img-default"
                  :src="item.icon"
                  :onerror="error_img"
                  alt=""
                />
              </div>
              <router-link
                :to="{ path: '/list', query: { id: item.id } }"
                v-text="item.name"
                :style="{ color: param.classify_font_color }"
              ></router-link>
            </div>
            <div class="ttshop_navsecond">
              <div class="ttshop_navsecondcon clearfloat">
                <div class="ttshop_navsecondleft">
                  <div class="ttshop_navsecondbut">
                    <div
                      class="ttshop_navseconlist d-flex"
                      v-for="(items, index) in item.child"
                      :key="index"
                    >
                      <router-link
                        :to="{ path: '/list', query: { id: items.id } }"
                        v-text="items.name"
                      ></router-link>
                      <ul
                        class="clearfloat"
                        v-if="items.child && items.child.length"
                      >
                        <li
                          v-for="(itemthree, index) in items.child"
                          :key="index"
                        >
                          <router-link
                            :to="{ path: '/list', query: { id: itemthree.id } }"
                            v-text="itemthree.name"
                          ></router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="ttshop_navsecondright">
                  <div class="ttshop_navbutton">
                    <div class="ttshop_navbuttonlist">
                      <img
                        class="img-default"
                        :src="item.advert_pic"
                        :onerror="error_img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="banner" :class="{ active: param.style == 0 }">
        <div
          class="swiper-container swiper-banner"
          :class="{ active: param.fill == 1 }"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in param.list"
              :key="index"
            >
              <template v-if="item.page_url.indexOf('http') != -1">
                <a :href="item.page_url" target="_blank"
                  ><img class="img-default" :src="item.pic_url" alt
                /></a>
              </template>
              <template v-else>
                <router-link :to="item.page_url"
                  ><img class="img-default" :src="item.pic_url" alt
                /></router-link>
              </template>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next"></div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="user">
        <div class="user-t">
          <div class="ttshop_tloding">
            <div class="ttshop_tlodingimg">
              <img
                class="img-default"
                src="../../../assets/images/ttshop_userimg.jpg"
                alt=""
                v-if="login"
              />
              <router-link to="/ttshop_user" v-else>
                <img
                  class="img-default"
                  :src="user.avatar_url"
                  :onerror="error_img"
                />
              </router-link>
            </div>
            <div class="ttshop_userloidng" v-if="login">
              <div class="ttshop_userloidngs clearfloat">
                <router-link to="/signin">登录</router-link>
                <router-link to="/register">注册</router-link>
              </div>
            </div>
            <div class="ttshop_userloidngover" v-else>
              <router-link
                class="ttshop_userloidngovers clearfloat"
                to="/ttshop_user"
              >
                <p>
                  HI,<a href="javascript:void(0);" v-text="user.nickname"></a>
                  您好
                </p>
                <strong @click.stop="signout()">退出</strong>
              </router-link>
            </div>

            <div class="ttshop_newuser">
              <div class="ttshop_newusers clearfloat">
                <div @click="toPersonal">新人有礼</div>
                <div @click="toPersonal">PLUS会员</div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-c">
          <div class="user-c-title">
            <div class="title-l">动态</div>
            <router-link to="/ttshop_details" class="title-r">更多</router-link>
          </div>
          <div class="user-c-list">
            <div
              class="list-item"
              v-for="(item, index) in param.article_list"
              :key="index"
            >
              <div class="list-item-l">最新</div>
              <router-link
                :to="{
                  path: '/ttshop_details',
                  query: { article_id: item.id },
                }"
                v-text="item.title"
                class="list-item-r"
              ></router-link>
            </div>
          </div>
        </div>
        <div class="user-b">
          <template v-for="(item, index) in param.icon_list">
            <template v-if="item.page_url.indexOf('http') != -1">
              <a :href="item.page_url" target="_blank" class="user-b-item">
                <img class="img-default" :src="item.pic_url" alt />
                <span v-text="item.title"></span>
              </a>
            </template>
            <template v-else>
              <router-link :to="item.page_url" class="user-b-item">
                <img class="img-default" :src="item.pic_url" alt />
                <span v-text="item.title"></span>
              </router-link>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  props: {
    param: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      user: {},
      login: true,
      error_img:
        'this.src="' + require("../../../assets/images/lodingsb.svg") + '"', //图片加载失败
    };
  },
  created() {
    this.common.loginType(this);
  },
  mounted() {
    new Swiper(".swiper-banner", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      loop: true, // 循环模式选项
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      effect: "fade",
      observer: true,
      observeParents: true,
      fadeEffect: {
        crossFade: true,
      },
    });
  },
  methods: {
    //退出登录
    signout() {
      this.common.signout(this);
    },
    // 进入个人中心
    toPersonal() {
      this.common.toPersonal(this);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .swiper-pagination {
  text-align: left;
  left: 30px;
}
.swiper-button-prev {
  width: 32px;
  height: 32px;
  background: url(../../../assets/images/ttshop_userleft.png) center no-repeat;
  left: 0;
  outline: none;
}

.swiper-button-prev::after {
  display: none;
}

.swiper-button-next {
  width: 32px;
  height: 32px;
  background: url(../../../assets/images/ttshop_useright.png) center no-repeat;
  right: 0px;
  outline: none;
}

.swiper-button-next::after {
  display: none;
}
.module-box-banner {
  min-width: 100vw;
  margin-left: calc((1190px - 100vw) / 2);
  position: relative;
}
.top.active {
  margin-top: 0 !important;
}
.top {
  margin-top: 10px !important;
  display: flex;
  justify-content: space-between;

  .nav {
    height: 480px;
    width: 190px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
    z-index: 3;
    &:hover {
      .nav-box {
        opacity: 0.8;
      }
    }
    & > ul {
      padding: 16px 0;
    }
    li {
      width: 100%;

      .ttshop_navtitle {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        height: 40.6px;
        line-height: 40.6px;
        padding-left: 37px;
        cursor: pointer;

        .ttshop-nav-icon {
          width: 16px;
          height: 16px;
          float: left;
          position: absolute;
          left: 12px;
          top: 12.3px;
        }

        a {
          font-size: 14px;
          color: #333;
          cursor: pointer;
          position: relative;
          margin-right: 6px;
          transition: all 0.4s;
          font-weight: 400;
          overflow: hidden;
          float: left;
          max-height: 40.6px;

          &::before {
            content: "/";
            font-size: 12px;
            color: #333;
            position: absolute;
            top: -1px;
            right: -6px;
            line-height: 1.5;
          }
          &:last-child::before {
            display: none;
          }
        }

        &:hover {
          // box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
          background-color: rgba(0, 0, 0, 0.05);
        }
      }

      &:hover {
        .ttshop_navsecond {
          display: block;
        }
      }

      .ttshop_navsecond {
        display: none;
        position: absolute;
        top: 0px;
        left: 190px;
        width: 1000px;
        min-height: 480px;
        padding: 18px 24px;
        box-sizing: border-box;
        background: #fff;
        z-index: 1000;
        // box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);

        .ttshop_navsecondcon {
          width: 100%;

          .ttshop_navsecondleft {
            float: left;

            .ttshop_navseconduptitle {
              width: 100%;
              margin-bottom: 20px;

              span {
                float: left;
                font-size: 12px;
                color: #ff0e25;
                background: #fff0f1;
                padding: 6px 12px;
                line-height: 12px;
                box-sizing: border-box;
                margin-right: 16px;
                transition: 0.5s;
                -moz-transition: 0.5s;
                -webkit-transition: 0.5s;
                -o-transition: 0.5s;
                cursor: pointer;
                border-radius: 2px;

                &:last-child {
                  margin-right: 0;
                }

                &:hover {
                  background: #ff0e25;
                  color: #fff;
                }
              }
            }

            .ttshop_navsecondbut {
              width: 100%;

              .ttshop_navseconlist {
                width: 100%;

                &:last-child {
                  margin-bottom: 0;
                }

                a {
                  float: left;
                  width: 78px;
                  padding: 12px 10px 12px 0;
                  font-size: 14px;
                  line-height: 20px;
                  color: #333;
                  // font-weight: 600;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                  cursor: pointer;
                  text-align: left;

                  &:hover {
                    color: #ff0e25;
                  }
                }

                ul {
                  float: left;
                  width: 636px;
                  padding: 6px 0 12px;
                  border-bottom: 1px solid #f5f5f5;

                  li {
                    width: auto;
                    float: left;
                    margin: 8px 20px 0 0;

                    a {
                      float: none;
                      width: auto;
                      padding: 0;
                      font-size: 14px;
                      line-height: 16px;
                      color: #999;
                      font-weight: 400;
                      transition: 0.5s;
                      -moz-transition: 0.5s;
                      -webkit-transition: 0.5s;
                      -o-transition: 0.5s;

                      &:hover {
                        color: #ff0e25;
                        font-weight: 500;
                      }
                    }
                  }
                  li:last-child {
                    margin-right: 0;
                  }
                }
              }
            }
          }

          .ttshop_navsecondright {
            float: right;
            width: 218px;

            .ttshop_navbutton {
              width: 100%;

              .ttshop_navbuttonlist {
                width: 100%;
                height: 108px;
                cursor: pointer;

                &:last-child {
                  margin-bottom: 0;
                }

                img {
                  width: 100%;
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .nav-box {
      width: 800px;
      height: 480px;
      background: #ebebeb;
      position: absolute;
      left: 190px;
      top: 0;
      z-index: 10;
      opacity: 0;
      transition: 0.35s;
      -moz-transition: 0.35s;
      -webkit-transition: 0.35s;
      -o-transition: 0.35s;
    }
  }

  .banner {
    width: 770px;
    height: 480px;
    .swiper-banner {
      width: 100%;
      height: 480px;
      .swiper-slide {
        height: 100%;
        width: 100%;
      }
    }
    .swiper-banner.active img {
      -o-object-fit: contain;
      object-fit: contain;
    }
  }
  .banner.active {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .user {
    height: 480px;
    width: 210px;
    background-color: #fff;
    position: relative;
    z-index: 2;

    .user-t {
      height: 154px;
      border-bottom: 1px solid #ebebeb;
      padding-top: 32px;
      box-sizing: border-box;

      .ttshop_tloding {
        width: 100%;

        .ttshop_tlodingimg {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin: 0 auto 12px;

          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }

        .ttshop_userloidng {
          width: 100%;
          display: block;
          margin-bottom: 18px;

          .ttshop_userloidngs {
            display: table;
            margin: 0 auto;

            a {
              float: left;
              font-size: 12px;
              color: #333;
              margin-right: 10px;
              position: relative;
              cursor: pointer;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &::before {
                content: "";
                width: 1px;
                height: 12px;
                background: #333;
                position: absolute;
                top: 3px;
                right: -5px;
              }

              &:hover {
                color: #ff0e25;
              }

              &:last-child {
                margin-right: 0;
              }

              &:last-child::before {
                display: none;
              }
            }
          }
        }

        .ttshop_userloidngover {
          width: 100%;
          margin-bottom: 18px;

          .ttshop_userloidngovers {
            display: table;
            margin: 0 auto;

            p {
              float: left;
              font-size: 12px;
              color: #333;
              position: relative;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              margin-right: 10px;

              &::before {
                content: "";
                width: 1px;
                height: 12px;
                background: #333;
                position: absolute;
                top: 3px;
                right: -5px;
              }

              a {
                font-size: 12px;
                color: #ff0e25;
              }
            }

            strong {
              float: left;
              font-size: 12px;
              color: #333;
              font-weight: 400;
              cursor: pointer;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover {
                color: #ff0e25;
              }
            }
          }
        }

        .ttshop_newuser {
          width: 100%;

          .ttshop_newusers {
            display: table;
            margin: 0 auto;

            div {
              cursor: pointer;
              display: block;
              float: left;
              width: 77px;
              height: 26px;
              border-radius: 25px;
              font-size: 14px;
              color: #fff;
              text-align: center;
              line-height: 26px;
              background: #ff0e25;
              margin-right: 12px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover {
                box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
              }

              &:last-child {
                background: #ff9010;
                margin-right: 0;
              }

              &:last-child:hover {
                box-shadow: 0 0 10px rgba(255, 144, 16, 0.3);
              }
            }
          }
        }
      }
    }

    .user-c {
      height: 170px;
      border-bottom: 1px solid #ebebeb;
      padding: 0 16px;
      box-sizing: border-box;

      .user-c-title {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title-l {
          font-size: 14px;
          color: #333333;
        }

        .title-r {
          color: #999999;
          font-weight: 400;
          transition: color 0.3s;
        }
        .title-r:hover {
          color: #ff0e25;
          font-weight: 500;
        }
      }

      .user-c-list {
        .list-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .list-item-l {
            width: 36px;
            height: 20px;
            line-height: 20px;
            background: #fff0f1;
            border-radius: 3px;
            color: #ff0e25;
            display: flex;
            justify-content: center;
            align-content: center;
            flex-shrink: 0;
          }

          .list-item-r {
            width: 134px;
            margin-left: 8px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .user-b {
      height: 156px;
      padding: 8px 20px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;

      .user-b-item {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          height: 32px;
          width: 32px;
        }

        span {
          margin-top: 8px;
          line-height: 12px;
        }
      }
    }
  }
}
</style>
